import { useState, useEffect, useCallback, useRef } from 'react';
import reportsApi from '../services/reportsApi';

export const useReports = (reportType, filters = {}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // To handle debounce
  const debounceRef = useRef(null);

  const fetchReport = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      let response;

      switch (reportType) {
        case 'attendance':
          response = await reportsApi.getAttendanceReport(filters);
          break;

        case 'issue':
          response = await reportsApi.getIssueReport(filters);
          break;

        case 'stock':
          response = await reportsApi.getStockReport(filters);
          break;

        case 'low_stock':
          response = await reportsApi.getLowStockReport(filters);
          break;

        case 'expiry':
          response = await reportsApi.getExpiryReport(filters);
          break;

        case 'movement':
          response = await reportsApi.getMovementSummary(filters);
          break;

        case 'top_consumed':
          response = await reportsApi.getTopConsumed(filters);
          break;

        default:
          throw new Error('Invalid report type');
      }

      setData(response?.data || null);
    } catch (err) {
      setError(err?.message || 'Failed to fetch report');
    } finally {
      setLoading(false);
    }
  }, [reportType, filters]);

  // Debounced API call when filters change
  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      fetchReport();
    }, 300); // 300ms debounce

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [fetchReport]);

  // Manual refetch (no debounce)
  const refetch = useCallback(() => {
    fetchReport();
  }, [fetchReport]);

  return {
    data,
    loading,
    error,
    refetch
  };
};